import React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { Button } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../i18n'
import { ButtonContainer, StyledText, TextContainer } from './SaveSearchForm.styles'

const PRE = `${i18nKeyPrefix}-SAVE-LOGGED-IN`

interface IProps {
  loading: boolean
  handleSubmit: () => void
}

export default function LoggedInForm(props: IProps) {
  const { loading, handleSubmit } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <React.Fragment>
      <TextContainer>
        <StyledText>{t(`${PRE}-TITLE`)}</StyledText>
      </TextContainer>
      <ButtonContainer>
        <Button disabled={loading} full onClick={() => handleSubmit()}>
          {loading ? t(`${PRE}-SAVING`) : t(`${PRE}-SAVE`)}
        </Button>
      </ButtonContainer>
    </React.Fragment>
  )
}
